import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { templateCategories } from '../data/content';
export function TemplatesCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(i => (i + 1) % templateCategories.length);
  const prev = () => setCurrentIndex(i => (i - 1 + templateCategories.length) % templateCategories.length);
  return <div className="relative max-w-sm mx-auto mt-4" data-id="element-173" data-mp="382m05bt3gp13">
      <div className="overflow-hidden rounded-[1.5rem] bg-fil-bg border border-fil-beige" data-id="element-174" data-mp="38110x8vu4hww">
        <AnimatePresence mode="wait" data-id="element-175" data-mp="3d3068ob4xowh">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="p-5 flex flex-col h-full" data-id="element-176" data-mp="3czujhfpzaz3x">
            <img src={templateCategories[currentIndex].img} alt={`Portada de la colección ${templateCategories[currentIndex].label}`} className="w-full h-auto mb-4 rounded-xl object-cover" data-id="element-177" data-mp="1w1hlh0w01c4d" />
            <h4 className="font-serif font-bold text-fil-text text-lg leading-tight mb-2 text-center" data-id="element-178" data-mp="1m9v2gidf68r2">
              {templateCategories[currentIndex].label}
            </h4>
            <p className="text-sm text-fil-taupe leading-snug text-center" data-id="element-179" data-mp="2ezaftesk4dq5">
              {templateCategories[currentIndex].desc}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <button type="button" onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white border border-fil-beige text-fil-cocoa flex items-center justify-center hover:text-fil-terra transition-colors duration-150 ease-out shadow-md z-10" aria-label="Ver colección anterior" data-id="element-180" data-mp="250ulz425aqcy">
        <ChevronLeftIcon size={18} data-id="element-181" data-mp="pjauz0fkszuo" />
      </button>
      <button type="button" onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-10 h-10 rounded-full bg-white border border-fil-beige text-fil-cocoa flex items-center justify-center hover:text-fil-terra transition-colors duration-150 ease-out shadow-md z-10" aria-label="Ver colección siguiente" data-id="element-182" data-mp="pmqbm7owegy7">
        <ChevronRightIcon size={18} data-id="element-183" data-mp="m1n8lldbivtj" />
      </button>

      <div className="flex justify-center gap-2 mt-5" data-id="element-184" data-mp="m4j4l45lvafc">
        {templateCategories.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-6 bg-fil-terra' : 'w-2 bg-fil-beige hover:bg-fil-rose'}`} aria-label={`Ir a la colección ${idx + 1}`} data-id="element-185" data-mp="89qghhbnglx5" data-mpi={idx} />)}
      </div>
    </div>;
}